// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".member-benefit-template .detailSection[data-v-269e726a] {\n  border: none !important;\n}\n.totalProfit-rate-tips[data-v-269e726a] {\n  color: var(--prev-color-prompt-color);\n  font-size: 12px;\n}\n.totalProfit-rate-color[data-v-269e726a] {\n  color: var(--prev-color-prompt-color);\n  cursor: pointer;\n}", ""]);
// Exports
module.exports = exports;
